import React from 'react'
import HeaderSection from '../../components/header'
import CommonHeroSection from '../../components/CommonHeroSection/CommonHeroSection'
import ChimneySweepSection from './ChimneySweepSection'
import serviceman from '../../assets/chimneySweepBg1.png'

import Footer from '../../components/footerSection'
import image2 from "../../assets/serviceBg.png";
import OurGlorySection from '../../components/OurGlorySection'

import faqImg from '../../assets/webInspectionImg.png'
import ContactUsSection from '../../components/servicesSection/ContactUsSection'
import FAQsSection from '../../components/FAQsSection'


export default function ServicePageWetInsception() {

    const ExpandDataAll = [
        {
            question: "WHY get WETT Certified Inspection?",
            answer: `WETT Inspections offer unmatched safety expertise for your fireplace. Trained
          inspectors ensure everything is up to code, unlike generic sweeps. Plus,
          WETT certification is often required for home insurance. Enjoy winter nights
          worry-free with a WETT Inspection`,
        },
        {
            question: "WHEN to get your WETT Inspection done?",
            answer: `You need to clean your chimney to prevent chimney fires and ensure efficient 
                  burning. Soot buildup is flammable, and a clean chimney allows proper airflow 
                  for optimal heat and safety.`,
        },
        {
            question: "How long is the WETT Inspection Valid for?",
            answer: `You need to clean your chimney to prevent chimney fires and ensure efficient 
                  burning. Soot buildup is flammable, and a clean chimney allows proper airflow 
                  for optimal heat and safety.`,
        },
        {
            question: "WHAT are different levels of WETT Inspection?",
            answer: `You need to clean your chimney to prevent chimney fires and ensure efficient 
                  burning. Soot buildup is flammable, and a clean chimney allows proper airflow 
                  for optimal heat and safety.`,
        },
    ];


    return (
        <div>
            <HeaderSection

            />
            <CommonHeroSection
                imgName={image2}
                titleHead="WETT Inspection"
                extraContent={`Home > Our Services > WETT Inspection`}
            />
            <ChimneySweepSection
                firstSentence={`WETT Inspection with`}
                secSentence={`Leduc Chimney Sweep Ltd`}
                thirdSentence={`.The Expert Eye for your chimney’s health.`}
                title={`Chimney Inspection:`}
                subTitle={` The WETT 
            Way it goes!`}
                extraContent={`WETT Inspection provides a thorough checkup for your wood-
            burning fireplace or appliance. Certified WETT inspectors are 
            trained to identify potential safety hazards like creosote buildup
             and ensure your chimney system is properly installed and 
            functioning efficiently. From the firebox and damper to the flue
             and chimney itself everything is carefully inspected.`}
             bgImg={serviceman}

            />
            <FAQsSection
                firstSentence={`Get safe and secure from fire hazards of fire place. Get your WETT Certified Inspection With`}
                secSentence={` Leduc Chimney Sweep`}
                thirdSentence={` TODAY!`}
                faqImg={faqImg}

                ExpandDataAll={ExpandDataAll}
            />
            <OurGlorySection />
            <ContactUsSection />

            <Footer />
        </div>
    )
}
